import Link from '@tiptap/extension-link';

/**
 * Custom TipTap extension for citations that preserves filename and page data
 * Uses data-* attributes which are preserved in HTML
 */
export const CitationExtension = Link.extend({
    name: 'citation',

    addAttributes() {
        return {
            ...this.parent?.(),
            // Citation-specific attributes stored as data-* attributes
            'data-filename': {
                default: null,
                parseHTML: element => element.getAttribute('data-filename'),
                renderHTML: attributes => {
                    if (!attributes['data-filename']) {
                        return {};
                    }
                    return {
                        'data-filename': attributes['data-filename'],
                    };
                },
            },
            'data-page': {
                default: null,
                parseHTML: element => {
                    const page = element.getAttribute('data-page');
                    return page ? parseInt(page, 10) : null;
                },
                renderHTML: attributes => {
                    if (!attributes['data-page']) {
                        return {};
                    }
                    return {
                        'data-page': attributes['data-page'].toString(),
                    };
                },
            },
        };
    },
});

